import { Box, SimpleGrid, Stat } from '@chakra-ui/react';
const stats = [
  {
    label: 'lat doświadczenia',
    value: '17',
  },
  {
    label: 'ocena na google.com',
    value: '5/5',
  },
  {
    label: 'godzin lekcyjnych',
    value: '33 900',
  },
  {
    label: 'użytych twierdzeń Pitagorasa',
    value: '3 812',
  },
];

export function HomeStats() {
  return (
    <Box as="section" py={{ base: 8, md: 16 }} px={{ base: 4, md: 8 }} bg="gray.50">
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} gap={{ base: 3, md: 6 }} maxW="7xl" mx="auto">
        {stats.map((stat) => (
          <Stat.Root
            key={stat.label}
            p={{ base: 2, md: 4 }}
            textAlign={{ base: 'center', md: 'left' }}
          >
            <Stat.ValueText alignSelf={{ base: 'center', md: 'left' }} fontSize={{ base: '2xl', md: '4xl' }} fontWeight="extrabold">
              {stat.value}
            </Stat.ValueText>
            <Stat.Label alignSelf={{ base: 'center', md: 'left' }} fontSize="md" color="gray.600">
              {stat.label}
            </Stat.Label>
          </Stat.Root>
        ))}
      </SimpleGrid>
    </Box>
  );
}
